import _ from 'lodash'
import { fetchCaseOptions } from '@/api/material/case'

export async function getCaseOptions(type: string, name: string) {
  const res = await fetchCaseOptions({
    type,
    keyword: name || '',
  })

  return (_.get(res, 'data.data.list') || []).map((item: any) => ({
    ...item,
    label: item.name,
  }))
}

function getFlatArr(arr: any[]) {
  return arr.reduce((a, item) => {
    let flatArr = [...a, item]
    if (item.child) {
      flatArr = [...flatArr, ...getFlatArr(item.child)]
    }
    return flatArr
  }, [])
}

function filterbrandLabel(data: any, value: string[]) {
  const labelAll = []
  for (const item of value) {
    for (const v of data) {
      if (Number(item) === v.id) {
        labelAll.push(v.name)
      }
    }
  }

  return labelAll.length > 0 ? labelAll.join(',') : '-'
}

export function getPlayMethodListByIds(ids: string, array: any[]) {
  let templateIdsTemp = []
  templateIdsTemp = ids.split(',')
  const newarry = getFlatArr(array)
  return filterbrandLabel(newarry, templateIdsTemp)
}
